<template>
	<view></view>
</template>

<script>
	export default {
		onLoad(options) {
			uni.redirectTo('/shop/pages/wallet/wallet')
		}
	}
</script>

<style lang="scss" scoped></style>